import * as Actions from 'store/actions/app/payment_types.actions'

const initialState = {
  loading_payment_types: false,
  payment_types: [],

  loading_payment_means: false,
  payment_means: null
}

const paymentTypesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PAYMENT_TYPES: {
      return {
        ...state,
        loading_payment_types: action.payload.loading ?? state.loading_payment_types,
        payment_types: action.payload.data ?? state.payment_types,
      }
    }
    case Actions.GET_PAYMENT_MEANS: {
      return {
        ...state,
        loading_payment_means: action.payload.loading ?? state.loading_payment_means,
        payment_means: action.payload.data ?? state.payment_means,
      }
    }
    default: {
      return state
    }
  }
}

export default paymentTypesReducer
